module.exports = __webpack_public_path__ + "static/media/clear.3b15dbbf.svg";